import React from "react";
import { Button, Input, Space } from "antd";
import { PlusOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";

const { Search } = Input;

interface AdminToolbarProps {
  search: string;
  activeLabel: string;
  showNew: boolean;
  onSearchChange: (value: string) => void;
  onReset: () => void;
  onNew: () => void;
}

export const AdminToolbar: React.FC<AdminToolbarProps> = ({
  search,
  activeLabel,
  showNew,
  onSearchChange,
  onReset,
  onNew,
}) => (
  <div className="admin-console__toolbar">
    <Space wrap className="admin-console__toolbar-actions">
      <Search
        allowClear
        placeholder={`Search ${activeLabel.toLowerCase()}...`}
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="admin-console__search"
      />
      <Button icon={<ReloadOutlined />} onClick={onReset}>Reset</Button>
      {showNew && (
        <Button type="primary" icon={<PlusOutlined />} onClick={onNew}>New</Button>
      )}
    </Space>
  </div>
);
